import { useLocalStorageValue } from "@react-hookz/web";
import { useMemo } from "react";

import { useUserFollow } from "~/components/follow-button/hooks";

import { useSnapshotState } from ".";

export const useMyNews = () => {
  const followedThreshold = 3;
  const { data } = useUserFollow();

  const { value: isVisitedMyNewsPage } = useLocalStorageValue("isVisitedMyNewsPage", {
    initializeWithValue: true,
    parse: raw => raw,
  });

  const computedFollowedList = useMemo(() => Object.values(data ?? {}).flat(), [data]);

  const [dataReference] = useSnapshotState(data);
  // Check the followed value by snapshot
  const initialHasEnoughFollowedItems = useMemo(
    () => Object.values(dataReference ?? {}).flat().length >= followedThreshold,
    [dataReference],
  );

  // Check the followed value by variable list
  const hasEnoughFollowedItems = useMemo(
    () => computedFollowedList.length >= followedThreshold,
    [computedFollowedList],
  );

  return {
    hasEnoughFollowedItems,
    initialHasEnoughFollowedItems,
    isVisitedMyNewsPage,
  };
};
